'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { Icon } from '../Icon';
import { Action } from '../Action';
import { useComponentDeprecation } from '../../util';

/** @deprecated use Price.InfoAction instead */
export const InfoIcon = props => {
  useComponentDeprecation({
    name: 'Price.InfoIcon',
    version: 'v5.0.0',
    alternative: 'Price.InfoAction'
  });
  return /*#__PURE__*/React.createElement(Icon.Compat, _extends({
    src: "system-information",
    size: "medium",
    fill: "var(--aui-primary)"
  }, props));
};
const StyledAction = styled(Action).withConfig({
  componentId: "aui__sc-fowznf-0"
})(["padding:var(--aui-spacing-050);"]);
export const InfoAction = props => /*#__PURE__*/React.createElement(StyledAction, _extends({
  size: 'sm',
  variant: 'flat'
}, props), /*#__PURE__*/React.createElement(Icon.SSR, {
  src: "system-information"
}));